import { Check } from 'lucide-react'

export default function CustomCheckbox({ checked, onChange, className = "", size = "md", disabled = false }) {
  // Size variants
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
  }


  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked)
    }
  }

  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-md ${
        disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer"
      } ${sizeClasses[size] || sizeClasses.md} ${className}`}
      onClick={handleClick}
      role="checkbox"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      <div
        className={`absolute inset-0 rounded-md transition-colors ${
          checked ? "bg-[#5B93FF]" : "bg-gray-100 border border-[#5B93FF]"
        } ${disabled ? "bg-opacity-70" : ""}`}
      ></div>
      {checked && (
        <Check className="relative text-black" size={size === "lg" ? 16 : size === "md" ? 14 : 12} strokeWidth={3} />
      )}
    </div>
  )
}